import React from "react";

const whyShopCards = [
  {
    title: "Trusted quality",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 3l7 3v5c0 4.2-2.7 7.9-7 10-4.3-2.1-7-5.8-7-10V6l7-3z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path d="M8.5 12.2l2.2 2.3 4.9-5.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Fast delivery",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M3.5 8.5h11v8h-11v-8z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path d="M14.5 11h3.5l2.5 2.5V16h-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="7" cy="17" r="1.6" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.5" cy="17" r="1.6" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
  },
  {
    title: "Secure checkout",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M7 10V8a5 5 0 1110 0v2"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M6 10h12v10H6V10z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path d="M12 13.5v2.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Helpful support",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 12a7 7 0 1114 0v4a2 2 0 01-2 2h-2v-5h3"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5 12h3v5H6a1 1 0 01-1-1v-4z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const WhyShopSection: React.FC = () => {
  return (
    <section className="shell section home-why-shop-section" aria-label="Why shop with Eldoo">
      <div className="home-why-shop">
        <div className="section-heading">
          <div>
            <span className="eyebrow">Why shop with us</span>
            <h2>Four reasons customers keep coming back</h2>
          </div>
        </div>
        <div className="home-why-shop__grid">
          {whyShopCards.map((card) => (
            <article key={card.title} className="home-why-shop__card">
              <span className="home-why-shop__icon" aria-hidden="true">
                {card.icon}
              </span>
              <h3>{card.title}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyShopSection;
